import React, { type FC } from 'react';
import { isJsmVirtualAgentOnPortalEAPAvailable } from 'feature-flags';
import { graphql, useFragment } from 'react-relay';
import { DisclaimerFooter } from 'unified-help-center-alpha/src/components/conversation/disclaimer-footer';
import { Box, xcss } from '@atlaskit/primitives';
import { media } from '@atlaskit/primitives/responsive';
import Spinner from '@atlaskit/spinner';
import { MessageList } from '@atlassian/help-center-conversation';
import { Appendices } from '../../common/ui/appendices';
import { useMessages, useIsLoading, useAppendices } from '../../controllers/conversation-store';
import type { conversationHelpseeker$key } from './__generated__/conversationHelpseeker.graphql';
import { Input } from './input/index';
import { MessageRenderer } from './message-renderer';

export const Conversation: FC<{ userRef: conversationHelpseeker$key | null | undefined }> = ({ userRef }) => {
    const messages = useMessages();
    const isLoading = useIsLoading();
    const appendices = useAppendices();

    const data = useFragment<conversationHelpseeker$key>(
        graphql`
            fragment conversationHelpseeker on User {
                ...messageRendererHelpseeker
            }
        `,
        userRef
    );

    return (
        <Box xcss={containerStyles}>
            <MessageList messageCount={messages.length}>
                {messages?.map((message) => (
                    <MessageRenderer key={message.id} userRef={data} messageResponse={message} />
                ))}
                {!isJsmVirtualAgentOnPortalEAPAvailable() && <Appendices appendices={appendices} />}
                {isLoading && <Spinner size="medium" />}
            </MessageList>
            <Box>
                <Input />
                <DisclaimerFooter />
            </Box>
        </Box>
    );
};

const containerStyles = xcss({
    [media.above.xs]: {
        width: '80vw',
    },

    [media.above.md]: {
        width: '60vw',
    },

    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    paddingBlock: 'space.500',
    boxSizing: 'border-box',
    gap: 'space.300',
});
